import React from 'react'
import styles from './title.styles'
import injectSheet from 'react-jss'

const Title = ({ classes, children }) => (
  <h2 className={classes.title}>{children}</h2>
)

export default injectSheet(styles)(Title)
